import ButtonKaraoke from '@/context/domain/g02/g02-d03/g02-d03-p001-karaoke/components/ButtonKaraoke';
import CurrentSong from '@/context/domain/g02/g02-d03/g02-d03-p001-karaoke/components/KaraokeSidebar/components/CurrentSong';
import SearchSong from '@/context/domain/g02/g02-d03/g02-d03-p001-karaoke/components/KaraokeSidebar/components/SearchSong';
import SongQueueList from '@/context/domain/g02/g02-d03/g02-d03-p001-karaoke/components/KaraokeSidebar/components/SongQueueList';
import CWButton from '@/context/global/components/g00/g00-d00-g006-cw-button';
import IconMusicFilter from '@/context/global/components/Icon/IconMusicFilterr';
import IconSearch from '@/context/global/components/Icon/IconSearch';
import IconSidebarRightCollapse from '@/context/global/components/Icon/IconSidebarRightCollapse';
import { TSong } from '@/context/global/types/song';
import { useTranslations } from 'next-intl';
import Image from 'next/image';

type QueueSidebarProps = {
  isOpen: boolean;

  onClose?: () => void;

  currentSong?: TSong | null;
  playlist: TSong[];

  onSongSelect?: (index: number) => void;
  onSongRemove?: (index: number) => void;
  onClearQueue?: () => void;
  onMoveToTop?: (index: number) => void;
  isPlaying: boolean;
  onTogglePlay?: () => void;

  isSearchOpen: boolean;
  setIsSearchOpen?: (isOpen: boolean) => void;
  hideSearch?: boolean;
  onAddToQueue?: (song: TSong) => void;
};

const KaraokeSidebar = ({
  isOpen,
  onClose,
  currentSong,
  playlist,
  onSongSelect,
  onSongRemove,
  onClearQueue,
  onMoveToTop,
  isPlaying,
  onTogglePlay,

  isSearchOpen,
  setIsSearchOpen,
  hideSearch,
  onAddToQueue,
}: QueueSidebarProps) => {
  const t = useTranslations('Karaoke.Sidebar');

  return (
    <div
      className={`flex h-full w-full transform flex-col border-l border-gray-800 bg-black px-[16px] pt-5 md:px-8 ${
        isOpen ? 'translate-x-0' : 'translate-x-full'
      }`}
    >
      {/* Header */}
      <div className="mb-4 hidden items-center justify-between md:flex">
        <Image
          width={162}
          height={0}
          sizes="100vw"
          src="/assets/ais-karaoke-logo.png"
          alt="Karaoke Logo"
        />
        <div className="flex items-center gap-3">
          {isSearchOpen ? (
            <ButtonKaraoke className="relative" onClick={() => setIsSearchOpen?.(false)}>
              <IconMusicFilter />
              <div className="absolute right-0 top-0 flex h-full max-h-5 w-full max-w-5 items-center justify-center rounded-full bg-ais-green text-xs font-bold text-black">
                {playlist.length > 99 ? 99 : playlist.length}
                {playlist.length > 99 && '+'}
              </div>
            </ButtonKaraoke>
          ) : (
            !hideSearch && (
              <ButtonKaraoke onClick={() => setIsSearchOpen?.(true)}>
                <IconSearch />
              </ButtonKaraoke>
            )
          )}
          <ButtonKaraoke onClick={onClose}>
            <IconSidebarRightCollapse />
          </ButtonKaraoke>
        </div>
      </div>

      {isSearchOpen ? (
        <SearchSong
          onBack={() => setIsSearchOpen?.(false)}
          currentSong={currentSong}
          onAddToQueue={onAddToQueue}
        />
      ) : (
        <>
          <div className="flex items-center justify-between">
            <h2 className="px-4 text-2xl font-medium text-white md:text-3xl">
              {t('songQueue')}
            </h2>

            <CWButton
              title={t('clear')}
              outline
              variant="gray"
              onClick={onClearQueue}
              className="transform text-xl transition-all hover:scale-110 md:text-2xl"
            />
          </div>

          <div className="my-4 h-0.5 bg-[#5E5E5E]" />

          {/* Currently Playing */}
          <CurrentSong
            song={currentSong}
            isPlaying={isPlaying}
            onTogglePlay={onTogglePlay}
          />

          {/* Queue List - Next Songs Only */}
          <SongQueueList
            playlist={playlist}
            onSongSelect={onSongSelect}
            onSongRemove={onSongRemove}
            onMoveToTop={onMoveToTop}
          />
        </>
      )}
    </div>
  );
};

export default KaraokeSidebar;
